import React from 'react'
import PropTypes from 'prop-types'

import Dots from 'Components/Blocks/_Legacy/Dots'

import { ChildContainer, DotsContainer, Wrapper } from './styles'

import Square from '../Square'

function Substrate({ children }) {
  return (
    <Wrapper>
      <DotsContainer>
        <Dots
          columns={71}
          corners={[true, true, true, true]}
          margin={14}
          rows={22}
        />
      </DotsContainer>
      <Square
        angle={-30}
        horizontalAlign={[-550, null]}
        isNotOnBody
        size={600}
        verticalAlign={[120, null]}
      />
      <Square
        angle={15}
        horizontalAlign={[null, -520]}
        isNotOnBody
        size={600}
        verticalAlign={[30, null]}
      />
      <ChildContainer>{children}</ChildContainer>
    </Wrapper>
  )
}

Substrate.propTypes = {
  children: PropTypes.object.isRequired,
}

export default Substrate
